import ajax from '@/lib/ajax';
import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import InvoiceDto from '@/models/Invoices/InvoiceDto';
import store from '@/store';
import { AppModule } from '@/store/modules/app';
import InvoiceSearchViewModel from '@/models/Invoices/InvoiceSearchViewModel';
import InvoiceSearchRequest from '@/models/Invoices/InvoiceSearchRequest';
import CompanyProfileDto from '@/models/Companies/CompanyProfileDto';
import CompanyProfileSearchRequest from '@/models/Companies/CompanyProfileSearchRequest';
import CreateInvoiceRequest from '@/models/Invoices/CreateInvoiceRequest';
import CompanyAddressDto from '@/models/CompanyAddresses/CompanyAddressDto';
import DeskDto from '@/models/Desks/DeskDto';
import PositionDto from '@/models/Positions/PositionDto';
import LocationDto from '@/models/Locations/LocationDto';
import BranchDto from '@/models/Branches/BranchDto';
import AgencyUserDto from '@/models/AgencyUsers/AgencyUserDto';
export interface IInvoiceListState {
  loading: boolean;
  invoices: InvoiceDto[];
  invoiceSearchViewModel: InvoiceSearchViewModel;
  newInvoiceId: string;
  loadingDialog: boolean;
}

@Module({ dynamic: true, store, name: 'InvoiceList', namespaced: true})
class InvoiceList extends VuexModule implements IInvoiceListState {
  
  public loading = false;
  public invoices: InvoiceDto[] = [];
  public invoiceSearchViewModel: InvoiceSearchViewModel = new InvoiceSearchViewModel();
  public newInvoiceId = '';
  public loadingDialog = false;
  public desks: DeskDto[] = [];

  @Action
  async searchInvoices() {
    const request = new InvoiceSearchRequest();

    if (this.invoiceSearchViewModel.selectedCompany != null) {
      request.companyId = this.invoiceSearchViewModel.selectedCompany.id;
    }

    if (this.invoiceSearchViewModel.selectedStatus != null) {
      request.status = this.invoiceSearchViewModel.selectedStatus;
    }

    if (this.invoiceSearchViewModel.selectedType != null) {
      request.type = this.invoiceSearchViewModel.selectedType;
    }

    if (this.invoiceSearchViewModel.weekCommencingDate) {
      request.weekCommencingDate = this.invoiceSearchViewModel.weekCommencingDate;
    }

    this.setLoading(true);
    await ajax.post(`/api/v1/agency/invoices/search`, request)
    .then(response => {
      this.context.commit("setInvoices", response.data);
      this.setLoading(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoading(false);
    });
  }

  @Action
  async getCompaniesForSearchOptions() {
    const request = new CompanyProfileSearchRequest();
    await ajax.post(`/api/v1/agency/companies/search`, request)
    .then(response => {
      if (response.data === null) {
        response.data = [];
      }
      this.context.commit("setCompanies", response.data);
    })
    .catch(error => {
      AppModule.handleApiError(error);
    });
  }

  @Action
  async getBranchesForSearchOptions() {
    await ajax.get(`/api/v1/agency/branches`)
    .then(response => {
      if (response.data === null) {
        response.data = [];
      }
      this.context.commit("setBranches", response.data);
    })
    .catch(error => {
      AppModule.handleApiError(error);
    });
  }

  @Action
  async getOwnersForSearchOptions() {
    await ajax.get(`/api/v1/agency/users`)
    .then(response => {
      if (response.data === null) {
        response.data = [];
      }
      this.context.commit("setOwners", response.data);
    })
    .catch(error => {
      AppModule.handleApiError(error);
    });
  }

    @Action
    async getDesks() {
    await ajax.get(`/api/v1/agency/desks`)
    .then(response => {
      if (response.data === null) {
        response.data = [];
      }
      this.context.commit("setDesks", response.data);
    })
    .catch(error => {
      AppModule.handleApiError(error);
    });
  }

  @Action
  public async createInvoice(request: CreateInvoiceRequest) {
    this.setLoadingDialog(true); 
    await ajax.post(`/api/v1/agency/invoices`, request)
    .then(response => {
      this.context.commit("setInvoiceIdFromCreate", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  cleanState() {
    this.context.commit("resetState");
  }

  @Mutation
  resetState() {
    this.invoices = [];
    this.newInvoiceId = '';
    this.invoiceSearchViewModel = new InvoiceSearchViewModel();
    this.loading = false;
    this.loadingDialog = false;
  }

  @Mutation
  private async setLoading(isLoading: boolean) {
      this.loading = isLoading;
  }

  @Mutation
  private async setLoadingDialog(isLoadingDialog: boolean) {
      this.loadingDialog = isLoadingDialog;
  }

  @Mutation
  private async setCompanies(companies: CompanyProfileDto[]) {
      this.invoiceSearchViewModel.companies = companies;
  }

@Mutation
  private async setDesks(desks: DeskDto[]) {
      this.desks = desks;
  }

  @Mutation
  private async setInvoices(invoices: InvoiceDto[]) {
      this.invoices = invoices;
  }

  @Mutation
  private async setInvoiceIdFromCreate(invoice: InvoiceDto) {
    this.newInvoiceId = invoice.id;
  }
}

export const InvoiceListModule = getModule(InvoiceList)
